import api from '../api/index';

const baseUrl = '/vehicle';

export const VinApi = (vin) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-car-fax/${vin}`,
  });
};

export const LookupApi = (plate, state) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-car-fax-plate/${plate}/${state}`,
  });
};
